<template>
    <div id="update-schedule" class="update-schedule">
        <div class="update-schedule-content mx-auto">
            <Heading
                fullWidth
                title="Updates Schedule"
                :description = "`
                    ${hasNoUpdates ? '' : 'You can send a cross-promotion request by choosing the preferred update date and spot.'}
                `"
            />
            <div 
                v-if="hasNoUpdates" 
                class="no-updates d-flex align-items-center justify-content-center p2b"
                >
                <p> 
                    No update date is scheduled. 
                    <span v-if="isNotAuthor">Request CrossProm by sending a message</span>
                </p>
            </div>
            <div class="update-schedule-place" v-else>
                <div
                    v-for="(item,index) in previewData.scheduler"
                    :key="`updates-${index}`"  
                    :id="`item-scheduler-${index}`"
                    class="d-flex justify-content-between align-items-center">
                    <div>
                        <p id="item-date" class="c3 p1n mb-0">{{item.date | formatDate}}</p>
                    </div>
                    <div>
                        <ul class="slots-list p-0 mt-3 d-flex justify-content-start">
                            <li 
                                v-for="(spot,index) in item.spots"
                                :key="`spot-${index}`"
                                :data-busy="item.busyIndexes.has(index)"
                                v-b-tooltip.hover="item.busyIndexes.has(index)? 'This spot is busy.': 'This spot is free'"
                                :id="`item-spot-${index}`"
                                class="slots-list-item">
                                    <p>{{index + 1}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <CpButton 
                v-if="isNotAuthor" 
                :campaign="previewData"
                :no-updates = "hasNoUpdates" 
                button-location = "Campaign Page"
            />
        </div>
    </div>
</template>

<script>
    import CpRequest from '@/components/CpRequest/modal.vue'
    import { mapState } from 'vuex'
    import moment from 'moment'
    import { getData } from "../../../firebaseCRUD";
    import Heading from "../../Theme/Heading";
    import CpButton from '../../CpButton'

export default {
    name: "UpdatesSchedule",
    components: {
        Heading,
        CpRequest,
        CpButton
    },
    props: {
        previewData: Object,
    },
    data() {
        return {
            docsCount: undefined,
            loading: false,
        }
    },
    computed: {
        ...mapState([
            'user'
        ]),
        loggedIn: function () {
            return this.user && this.user.uid
        },
        isNotAuthor(){
            return this.previewData.author_id !== this.user.uid
        },
        hasNoUpdates() {
           return this.previewData.scheduler && !this.previewData.scheduler.length 
        }
    },
    mounted: function() {
        if (this.loggedIn) {
            this.checkUserCampsLength()
        }
    },
    methods: {
        async checkUserCampsLength() {
            const doc = await getData('campaigns', {
                field: 'author_id',
                condition: '==',
                value: this.user.uid
            })
            this.docsCount = doc.docs.length
        },
        sendRequest: function() {
            if(!this.user.uid) {
                this.$store.commit('TOGGLE_MODAL', ['sign-up', {
                    openedFrom: 'CP Request Button'
                }])  
                return
            }

            this.$router.replace({
                query: {
                    ...this.$route.query,
                    project_id: this.previewData.id
                }
            })
            .catch(() => {})
            this.$store.commit('TOGGLE_MODAL', ['cp-request', true])   
        }
    },
    filters: {
        formatDate: (date) => moment.utc(date).format("DD/MM/YYYY")
    }
}
</script>

<style scoped lang="scss">
    @import '../../../assets/scss/variables.scss';
    .update-schedule {
        .update-schedule-content{
            width: 360px;
            padding-top: 38px;

            .no-updates {
                height: 500px;
                font-weight: $weight_bold;
                color: $c7;
                border-top: 1px solid #F4F4F4;
                border-bottom: 1px solid #F4F4F4;
                text-align: center;
                line-height: 28px;
            }

            .update-schedule-place {
                height: 465px;
                overflow-y: auto;
                border-top: 1px solid #F4F4F4;
                border-bottom: 1px solid #F4F4F4;

                ul.slots-list {
                    width: 205px;
                    li.slots-list-item {
                        width: 28px;
                        height: 28px;
                        border-radius: 50%;
                        background: #ffffff;
                        border: 1px solid #0ACF97;
                        margin-right: 13px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        p {
                            color: #0ACF97;
                            margin: 0;
                        }
                        &[data-busy] {
                            p {
                            color: #ffffff;

                            }
                            background-color: #B8CDD7;
                            border: 1px solid #B8CDD7;
                        }
                    }
                }
            }
            .update-schedule-footer {
                button {
                    width: 100%;
                    height: 52px;
                }
            }
        }

    }
</style>